/**
 * Reading optional VITE_* variables.
 *
 * Vite inlines a MISSING variable as undefined but an UNSET one as an empty
 * string, and the Dockerfile declares the optional ones with `=""` defaults so a
 * build without them still succeeds. `??` does not catch an empty string, so
 * reading one directly would hand a vendor `''` as a key or a host and break it
 * in exactly the deployment that forgot to set it.
 */
export const fromEnv = (value: unknown): string | undefined => {
  const text = typeof value === 'string' ? value.trim() : ''
  return text === '' ? undefined : text
}
